<template>
	<div style="padding: 10px; background-color: #fff;margin: 10px;border-radius: 3px;">
		<!--  border-bottom: 1px solid #eee; type="border-card" -->
		<!-- <el-tabs v-model="tabName" type="border-card">
			<el-tab-pane label="轮播图" name="轮播图"> -->
				<!-- 首页轮播图start box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);-->
				<div>

					<div style="position: sticky;top:0;z-index: 999;background-color: #fff;padding-bottom: 1px;border-bottom: 1px solid #ebeef5;">
						<!--带折叠的搜索start-->
						<div>
							<el-form size="mini" style="display: flex;flex-wrap: wrap;height:50px;padding-top: 5px;"  ref="searchFormSwiper" :model="searchFormSwiper" inline label-width="120px">

								<!--收起时显示的搜索项start 4个搜索项为一行-->
								<div style="width: 80%;display: flex;">

									<el-form-item label="类型" style="width: 23%;display: flex;">
										<el-select v-model="searchFormSwiper.type" clearable placeholder="请选择">
											<!-- 类型 (1: 首页横幅, 2: 活动(展示海报)), 3: 活动(跳转页面), 
												4: 活动(跳转小程序), 5: 活动(跳转公众号),
												6: 活动(节日节气) -->
											<el-option label="开屏封面" :value="7" />
											<el-option label="首页横幅" :value="1" />
											<el-option label="首页探索更多" :value="8" />
											<el-option label="首页查找门店" :value="9" />
											<el-option label="首页关于我们" :value="10" />
											
											<el-option label="活动(展示海报)" :value="2" />
											<el-option label="活动(跳转页面)" :value="3" />
											<el-option label="活动(跳转小程序)" :value="4" />
											<el-option label="活动(跳转公众号)" :value="5" />
											<el-option label="活动(节日节气)" :value="6" />
											

										</el-select>
									</el-form-item>

								</div>
								<!--收起时显示的搜索项end-->

								<div :style="{'width':'13%','justify-content': 'center' }" style="height: 30px; display: flex;margin: 0;margin-bottom: 10px;">
									<el-button round style="margin-right: 10px;" @click="handleSearchSwiper" type="primary" icon="el-icon-search" size="small">搜索</el-button>
									<el-button round @click="handleResetSwiper" size="small">重置</el-button>

								</div>


							</el-form>
						</div>
						<!--带折叠的搜索end-->

						<div style="display: flex;align-items: center;background-color: #fff;margin-bottom: 10px; justify-content: space-between;margin-left: 5px;">

							<div style="margin-right: 20px;margin-left: 35px;">
								<el-button @click="showAddSwiperPop" type="primary" round icon="el-icon-plus" size="mini">添加</el-button>
							</div>
						</div>
					</div>


					<!--表格start :height="tableHeight+'px'"-->
					<el-table :height="tableHeight" :show-header="false" ref="table" :data="tableDataSwiper" style="width: 100%;background-color: #fff;margin: 5px;">

						<el-table-column style="width: 100%;">
							<template slot-scope="{ row, index }">
								<div class="tableTem" style="display: flex;margin-left: 20px;">
									<div class="avatar">

										<!--用户图片start-->
										<div style="text-align: center;" class="dis">
											<img :src="row.image" style="width:70px;height:70px;cursor: pointer;" @click="handlePreView(row.image)">
											<!-- <div class="titleFont">主图</div> -->
										</div>
										<!--用户图片end-->

										<div style="width: 180px;">

											<!--头像右侧一个列表项start-->
											<div style="display: flex;">
												<span class="titleFont" style="width: 70px;text-align: right;">id：</span>
												<el-tooltip :content="row.id+''" placement="right">
													<div class="dian dianL">{{row.id}}</div>
												</el-tooltip>
											</div>
											<!--头像右侧一个列表项end-->
											<div style="display: flex;">
												<span class="titleFont" style="width: 70px;text-align: right;">名称：</span>
												<el-tooltip :content="row.name" placement="right">
													<div class="dian dianL">{{row.name}}</div>
												</el-tooltip>
											</div>
											
											<div style="display: flex;">
												<span class="titleFont" style="width: 70px;text-align: right;">排序：</span>
												<el-tooltip :content="row.sort+''" placement="right">
													<div class="dian dianL">{{row.sort}}</div>
												</el-tooltip>
											</div>

											<div style="display: flex;">
												<span class="titleFont" style="width: 70px;text-align: right;">状态：</span>
												<el-tooltip :content="row.deleted_at?'已删除':'正常'" placement="right">
													<div v-if="row.deleted_at" class="dian dianL" style="color: red;font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
														<div style="width: 10px;height: 10px;background-color: red;border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
														已删除
													</div>
													<div v-else class="dian dianL" style="color: rgb(103, 194, 58);font-size: 12px;padding-top: 1px;display: flex;align-items: center;">
														<div style="width: 10px;height: 10px;background-color: rgb(103, 194, 58);border-radius: 50%;display: inline-block;margin-right: 3px;"></div>
														正常
													</div>
												</el-tooltip>
											</div>



										</div>
									</div>

									<!-- height: 50px; -->
									<ul :style="{'width':isMobile?mobileWidth+'px':'','overflow-x':isMobile?'auto':'','overflow-y':isMobile?'hidden':'','flex-wrap':isMobile?'nowrap':''}">
										<!-- 一个方块列表项start-->
										<li style="width:150px;text-align: center;">
											<div class="content" style="text-align: center;width:150px">
												
												<!-- 类型 (1: 首页横幅, 2: 活动(展示海报), 3: 活动(跳转页面),
													4: 活动(跳转小程序), 5: 活动(跳转公众号),
													6: 活动(节日节气) -->

												<div v-if="row.type==1" class="dian" style="text-align: center;width:150px">首页横幅</div>
												<div v-if="row.type==2" class="dian" style="text-align: center;width:150px">活动(展示海报)</div>
												<div v-if="row.type==3" class="dian" style="text-align: center;width:150px">活动(跳转页面)</div>
												<div v-if="row.type==4" class="dian" style="text-align: center;width:150px">活动(跳转小程序)</div>
												<div v-if="row.type==5" class="dian" style="text-align: center;width:150px">活动(跳转公众号)</div>
												<div v-if="row.type==6" class="dian" style="text-align: center;width:150px">活动(节日节气)</div>
												<div v-if="row.type==7" class="dian" style="text-align: center;width:150px">开屏封面</div>
												<div v-if="row.type==8" class="dian" style="text-align: center;width:150px">首页探索更多</div>
												<div v-if="row.type==9" class="dian" style="text-align: center;width:150px">首页查找门店</div>
												<div v-if="row.type==10" class="dian" style="text-align: center;width:150px">首页关于我们</div>

											</div>
											<div class="titleFont">类型</div>
										</li>
										<!-- 一个方块列表项end-->
										
										
										
										<li>
											<div class="content" >
												<img v-if="row.poster" :src="row.poster" style="width:30px;height:30px;cursor: pointer;border-radius: 4px;" @click="handlePreView(row.poster)">
												<div v-else>无</div>
											</div>
											<div class="titleFont" :style="row.poster?'margin-top:-10px;':''">海报</div>
										</li>
										

										<li style="width: 150px;">
											<div class="content" style="width: 140px;">
												<el-tooltip :content="row.url?row.url:'无'" placement="right" style="width: 140px;">
													<div class="dian" style="width: 140px;">{{row.url?row.url:'无'}}</div>
												</el-tooltip>
											</div>
											<div class="titleFont">链接</div>
										</li>
										
										<li style="width: 150px;">
											<div class="content" style="width: 140px;">
												<el-tooltip :content="row.appid?row.appid:'无'" placement="right" style="width: 140px;">
													<div class="dian" style="width: 140px;">{{row.appid?row.appid:'无'}}</div>
												</el-tooltip>
											</div>
											<div class="titleFont">小程序id</div>
										</li>


									<!-- 	<li>
											<div class="content">

												<div class="dian">{{row.sort}}</div>

											</div>
											<div class="titleFont">排序</div>
										</li> -->



										<li>
											<el-tooltip :content="row.created_at+''" placement="right">

												<div class="content dis">
													{{row.created_at | timeBreak2}}
												</div>
											</el-tooltip>
											<div class="titleFont dian">创建时间</div>
										</li>

										<li>
											<el-tooltip :content="row.updated_at+''" placement="right">

												<div class="content dis">
													{{row.updated_at | timeBreak2}}
												</div>
											</el-tooltip>
											<div class="titleFont dian">更新时间</div>
										</li>
										
									

									</ul>


									<div style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
										<el-dropdown trigger="hover" style="width: 80px;">
											<el-button size="mini" round type="primary">
												操作<i class="el-icon-arrow-down el-icon--right"></i>
											</el-button>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item>
													<el-button type="success" size="mini" round @click="showAddSwiperPop(row)">编辑
													</el-button>
												</el-dropdown-item>
												<el-dropdown-item v-if="row.deleted_at">
													<el-button type="danger" size="mini" round @click="huiFuSwiper(row)">恢复
													</el-button>
												</el-dropdown-item>
												<el-dropdown-item v-else>
													<el-button type="danger" size="mini" round @click="delSwiper(row)">删除
													</el-button>
												</el-dropdown-item>


											</el-dropdown-menu>
										</el-dropdown>

									</div>

								</div>

							</template>
						</el-table-column>
					</el-table>
					
					<!--分页start-->
					<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;">
						<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
						<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
					</el-row>
					<!--表格end-->

				</div>
				<!-- 首页轮播图end -->

			<!-- </el-tab-pane>

		</el-tabs> -->






		<!-- 首页添加轮播图弹窗start -->
		<el-dialog :close-on-click-modal="false" width="600px" ref="form" custom-class="m-dialog" title="信息" center :visible.sync="isShowAddSwiperPop">
			<div v-if="isShowAddSwiperPop">
				<div style="padding-top: 20px;">

					<el-form style="margin-left: 80px;" label-width="100px" size="small" ref="formSwiper" :rules="formRulesSwiper" :model="formSwiper">

						<el-form-item label="类型" prop="type">
							<el-select v-model="formSwiper.type" clearable placeholder="请选择" style="width: 250px;">
								
								<!-- 类型 (1: 首页横幅, 2: 活动(展示海报)), 3: 活动(跳转页面),
									4: 活动(跳转小程序), 5: 活动(跳转公众号),
									6: 活动(节日节气) -->
								<el-option label="开屏封面" :value="7" />
								<el-option label="首页横幅" :value="1" />
								<el-option label="首页探索更多" :value="8" />
								<el-option label="首页查找门店" :value="9" />
								<el-option label="首页关于我们" :value="10" />
								
								<el-option label="活动(展示海报)" :value="2" />
								<el-option label="活动(跳转页面)" :value="3" />
								<el-option label="活动(跳转小程序)" :value="4" />
								<el-option label="活动(跳转公众号)" :value="5" />
								<el-option label="活动(节日节气)" :value="6" />
								
							</el-select>
						</el-form-item>

						<el-form-item label="名称" prop="name">
							<el-input style="width: 250px;" v-model="formSwiper.name" placeholder="请输入名称"></el-input>
						</el-form-item>

						<el-form-item label="图片" prop="image" style="position: relative;">
							<!-- <div style="position: absolute;top: 20px;left: -59px;font-size: 12px;color: #aaa;">680*910</div> -->
							<upload-img :limit='1'  ref="fengMianUploadSwiper"  accept="image/*" :imgList="formSwiper.image"></upload-img>
							<!-- :imgWidth="680" :imgHeight="910" :limit='1' accept="image/png" fileAfterName=".png"-->
						</el-form-item>
						
						<el-form-item v-if="formSwiper.type==2||formSwiper.type==6" label="海报" prop="poster" style="position: relative;">
							<!-- <div style="position: absolute;top: 20px;left: -59px;font-size: 12px;color: #aaa;">680*910</div> -->
							<upload-img :limit='1'  ref="haiBaoUploadSwiper" accept="image/*" :imgList="formSwiper.poster"></upload-img>
							<!-- :imgWidth="680" :imgHeight="910" :limit='1' accept="image/png" fileAfterName=".png"-->
						</el-form-item>

						<el-form-item v-if="formSwiper.type==3||formSwiper.type==4||formSwiper.type==5||formSwiper.type==8"  label="链接" prop="url">
							<el-input style="width: 250px;" v-model="formSwiper.url" placeholder="请输入链接"></el-input>
						</el-form-item>
						
						<el-form-item v-if="formSwiper.type==4"  label="小程序id" prop="appid">
							<el-input style="width: 250px;" v-model="formSwiper.appid" placeholder="请输入小程序id"></el-input>
						</el-form-item>

						<el-form-item label="排序" prop="sort">
							<el-input style="width: 250px;" type="number" min="0" max="100" v-model="formSwiper.sort" placeholder="请输入0-100的排序值"></el-input>
						</el-form-item>



					</el-form>

				</div>
				<div class="dis" style="justify-content: flex-end;">

					<el-button round style="margin-left: 10px" @click="saveSwiper('formSwiper')" type="primary" size="small">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 首页添加轮播图弹窗end -->


		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="400px" footer-hide title="预览" :visible.sync="isShowPreImg">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->


		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->
	</div>
</template>

<script>
	import {
		ajax
	} from '../../util/ajax.js';
	import uploadImg from '../../components/upload/uploadImg.vue'
	export default {
		name: '',
		components: {
			uploadImg
		},
		data() {
			return {
				mobileWidth:window.mobileWidth-40,
				isMobile:window.isMobile,
				isShowAddSwiperPop: false, //是否显示首页添加轮播图弹窗
				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址
				tableHeight: 0, //表格高度
				loading: false,

				
				searchFormSwiper: {}, //首页轮播图的搜索
				tableDataSwiper: [], //首页轮播图的表格数据
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				isShowCollapse: false, //是否展开搜索
			

			


				formSwiper: {
					banner_id: '',
					name: '',
					image: [],
					sort: 0,
					type: '',
					url: '',
					poster:[],
					appid:''
				},
				formRulesSwiper: {

					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					url: [{
						required: true,
						message: '请输入链接',
						trigger: 'blur'
					}],
					appid: [{
						required: true,
						message: '请输入小程序id',
						trigger: 'blur'
					}],
					type: [{

						required: true,
						message: '请选择类型',
						trigger: 'change'
					}],
					image: [{
						type: 'array',
						required: true,
						message: '请上传图片',
						trigger: 'change'
					}],
					poster: [{
						type: 'array',
						required: true,
						message: '请上传海报',
						trigger: 'change'
					}],
					sort: [{
						required: true,
						message: '请输入0-100的排序值',
						trigger: 'blur',

					}],



				},




			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},

			timeBreak2(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},

		mounted() {

			this.initData();
		},

		created() {
			this.getTableHeight();
		},
		mounted() {

			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};


			this.initData();
		},

		methods: {

			//初始化表格数据
			async initData() {
				
					this.indexSwiperInitData();
				

			},

			//删除首页轮播图项
			async delSwiper(row) {
				this.$confirm('确定要删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					let ress = await ajax('/hq/banner', 'DELETE', {
						banner_id: row.id,
						status: 0
					});
					this.loading = false;
					this.$message({
						message: '成功',
						type: 'success'
					});

					this.indexSwiperInitData();
				});
			},


			//恢复首页轮播图项
			async huiFuSwiper(row) {
				this.$confirm('确定要恢复吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					let ress = await ajax('/hq/banner', 'DELETE', {
						banner_id: row.id,
						status: 1
					});
					this.loading = false;
					this.$message({
						message: '成功',
						type: 'success'
					});

					this.indexSwiperInitData();
				});
			},

			
			//翻页
			changePage(pageNumber) {
				this.tableDataSwiper=[];//这种可以让滚动条回到顶部
				this.pageNumber = pageNumber
				this.indexSwiperInitData()
			},
			

			async indexSwiperInitData() {

				this.loading = true
				let param = {
					count: this.pageSize,
					page: this.pageNumber
				};
				if (this.searchFormSwiper.type) {
					param.type = this.searchFormSwiper.type;
				}
				console.log('param==>', this.searchFormSwiper.type)
				let ress = await ajax('/hq/banner', 'GET', param);
				this.loading = false;
				let res = ress.data.data;
				this.total = res.total;
				this.tableDataSwiper = res.banner;
			},





			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 238; //距离页面下方的高度,值越大表格高度越小
				let tableHeightDetil = window.innerHeight - tableH;
				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},


			//点击添加或编辑首页轮播图按钮
			showAddSwiperPop(row) {
				if (row.id) { //编辑
					console.log('row===>', row)
					this.formSwiper.banner_id = row.id;
					this.formSwiper.name = row.name;
					if(row.poster){
						this.formSwiper.poster = [{
							url: row.poster
						}];
					}else{
						this.formSwiper.poster = [];
					}
					
		
					
					
					if(row.image){
						this.formSwiper.image = [{
							url: row.image
						}];
					}else{
						this.formSwiper.image = [];
					}
					
					this.formSwiper.sort = row.sort;
					this.formSwiper.type = row.type;
					this.formSwiper.url = row.url;
					this.formSwiper.appid = row.appid;
				}else{
					this.formSwiper = {
						banner_id: '',
						name: '',
						image: [],
						sort: 0,
						type: '',
						url: '',
						poster:[],
						appid:''
					};
				}
				this.isShowAddSwiperPop = true;
			},
			//浏览图片
			handlePreView(url) {
				this.preImgUrl = url
				this.isShowPreImg = true
			},

			//首页轮播图的搜索
			handleSearchSwiper() {

				this.initData()
			},
			//首页轮不同的重置
			handleResetSwiper() {
				this.searchFormSwiper = {};
				this.tableDataSwiper = []; //表格数据修改为空
				this.pageNumber = 1;
				this.pageSize = 10;
				
				this.initData()
			},

			//首页轮播图添加或编辑
			async saveSwiper(formName) {
				if(this.$refs.haiBaoUploadSwiper){
					this.formSwiper.poster = this.$refs.haiBaoUploadSwiper.getImgList();
				}
				
				this.formSwiper.image = this.$refs.fengMianUploadSwiper.getImgList(); //商品封面图
				this.$refs[formName].validate(async (valid) => {
					if (valid) {

						// if (this.formSwiper.sort < 0 || this.formSwiper.sort > 100) {
						// 	this.$message.error('请填写0-100的排序值');
						// 	return
						// }
						
						let param = {
							name: this.formSwiper.name,
							image: this.formSwiper.image[0].url,
							sort: this.formSwiper.sort,
							type: this.formSwiper.type
						};
						let method = "POST";
						if (this.formSwiper.banner_id) {
							method = 'PUT';
							param.banner_id= this.formSwiper.banner_id;
						}
						
						
						if(this.formSwiper.type==2||this.formSwiper.type==6){
							this.formSwiper.poster = this.$refs.haiBaoUploadSwiper.getImgList(); //海报
							param.poster = this.formSwiper.poster[0].url;
						}
						
						if(this.formSwiper.type==3||this.formSwiper.type==4||this.formSwiper.type==5||this.formSwiper.type==8){
							param.url = this.formSwiper.url;
						}
						
						if(this.formSwiper.type==4){
							param.appid = this.formSwiper.appid;
						}
						
						
						
						this.loading = true;
						let ress = await ajax('/hq/banner', method, param);
						this.loading = false;

						this.$refs[formName].resetFields();
						this.formSwiper = {
							banner_id: '',
							name: '',
							image: [],
							sort: 0,
							type: '',
							url: '',
							poster:[],
							appid:''
						};

						this.$message({
							message: '成功',
							type: 'success'
						});
						this.isShowAddSwiperPop = false;
						this.indexSwiperInitData();

					} else {
						this.$message.error('请填写完整信息');
						return false;
					}
				});



			},







		}



	}
</script>

<style scoped>
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;
		color: #2d8cf0;
		font-weight: 600;
	}

	.tableTem .avatar img {
		border-radius: 10px;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {

		padding-right: 20px;
		display: flex;
		justify-content: center;

	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.tableTem .dianL {
		text-align: left;
		font-size: 13px;
		color: #333;
	}


	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
	}

	.sortItem {

		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		min-width: 80px;
	}

	.sortItem:hover {
		background-color: #9E819F !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.el-table tbody tr:hover>td {
		background-color: #ffffff !important
	}


	>>>.el-icon-arrow-down {
		font-size: 12px;
	}

	>>>.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	>>>.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	>>>.el-table td {
		padding: 10px 0 !important;
	}
</style>
